// format.ts — render-boundary numeric formatting (CV-813).
// Partial cv-cad exports (.cvt templates, see CV-810) carry undefined mpvar
// fields; arithmetic on them yields NaN. Never let NaN reach the DOM — coerce
// to an em-dash at the render boundary. Zero is a valid value, not missing.

export const EM_DASH = '—';

/**
 * Format a numeric value for display, or return '—' when the value is
 * missing (undefined/null) or not finite (NaN/Infinity).
 */
export function formatNumberOrDash(
  value: number | null | undefined,
  unit?: string,
  fractionDigits?: number,
): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return EM_DASH;
  const s = fractionDigits !== undefined ? value.toFixed(fractionDigits) : String(value);
  return unit ? `${s} ${unit}` : s;
}
